import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function EmailCommunication(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Network", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M30.2409 14.5865H15.758V7.23643c0-.35531.1412-.69606.3924-.94729.2512-.25124.592-.39238.9473-.39238h13.1432v8.68974Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M15.758 14.5861h14.4829v1.4482c0 .3842-.1526.7525-.4242 1.0241-.2716.2717-.64.4242-1.0241.4242H17.2063c-.3841 0-.7525-.1525-1.0241-.4242-.2716-.2716-.4242-.6399-.4242-1.0241v-1.4482Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M22.9995 16.7593c.4 0 .7242-.3242.7242-.7241 0-.4-.3242-.7242-.7242-.7242-.3999 0-.7241.3242-.7241.7242 0 .3999.3242.7241.7241.7241Zm-2.237.7241h4.3955l.7387 2.1724h-5.7932l.659-2.1724Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M22.2754 3h10.138v7.2414h-10.138V3Z", fill: theme.vars.palette.primary.light }),
    /* @__PURE__ */ jsx("path", { d: "m22.2754 3 5.069 4.34487L32.4134 3", fill: theme.vars.palette.secondary.dark }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M41.8288 35.5871H27.3459V28.237c0-.3553.1412-.696.3924-.9473.2513-.2512.592-.3924.9473-.3924h13.1432v8.6898Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M27.3459 35.5866h14.4829v1.4483c0 .3841-.1525.7525-.4242 1.0241-.2716.2716-.6399.4242-1.024.4242H28.7942c-.3841 0-.7525-.1526-1.0241-.4242-.2716-.2716-.4242-.64-.4242-1.0241v-1.4483Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M34.5864 37.7588c.4 0 .7242-.3242.7242-.7241s-.3242-.7242-.7242-.7242c-.3999 0-.7241.3243-.7241.7242s.3242.7241.7241.7241Zm-2.238.7241h4.3956l.7386 2.1724h-5.7931l.6589-2.1724Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M33.8623 24h10.138v7.2414h-10.138V24Z", fill: theme.vars.palette.primary.light }),
    /* @__PURE__ */ jsx("path", { d: "m33.8623 24 5.069 4.3449L44.0003 24", fill: theme.vars.palette.secondary.dark }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M16.4829 35.5871H2V28.237c0-.3553.14114-.696.39238-.9473.25124-.2512.59199-.3924.94729-.3924H16.4829v8.6898Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M2 35.5866h14.4829v1.4483c0 .3841-.1526.7525-.4242 1.0241-.2716.2716-.64.4242-1.0241.4242H3.44829c-.38411 0-.75249-.1526-1.0241-.4242C2.15259 37.7874 2 37.419 2 37.0349v-1.4483Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M9.24075 37.7588c.39993 0 .72414-.3242.72414-.7241s-.32421-.7242-.72414-.7242c-.39994 0-.72415.3243-.72415.7242s.32421.7241.72415.7241Zm-2.23781.7241h4.39556l.7386 2.1724H6.34396l.65898-2.1724Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M8.5166 24h10.138v7.2414H8.5166V24Z", fill: theme.vars.palette.primary.light }),
    /* @__PURE__ */ jsx("path", { d: "m8.5166 24 5.069 4.3449L18.6546 24", fill: theme.vars.palette.secondary.dark }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M4.89612 24.0001c-.19206 0-.37625-.0763-.51205-.2121-.13581-.1358-.2121-.32-.2121-.512-.00183-2.7664.60736-5.499 1.78406-8.0026 1.1767-2.5036 2.89185-4.7164 5.02287-6.48033.0732-.06097.1577-.10691.2486-.13519.091-.02827.1866-.03832.2815-.02958.0948.00875.187.03612.2713.08054.0842.04443.1589.10505.2197.17837.0609.07317.1069.15766.1352.24861.0282.09096.0383.1866.0295.28144-.0087.09485-.0361.18704-.0805.27129-.0444.08425-.105.15891-.1784.2197-1.96791 1.62735-3.55186 3.66965-4.63848 5.98055-1.08662 2.311-1.64905 4.8335-1.64706 7.3872 0 .192-.07629.3762-.2121.512-.1358.1358-.31999.2121-.51204.2121ZM22.9997 42.1037c-1.5226.0015-3.0398-.1808-4.5186-.5431-.1921-.0461-.358-.1666-.4612-.335-.1032-.1684-.1353-.3709-.0892-.5629.0461-.1921.1666-.358.335-.4612.1684-.1032.3709-.1353.563-.0892 2.0097.4947 4.0912.6295 6.1479.3983.1921-.0211.3847.0349.5354.1558.1508.1208.2473.2966.2685.4887.0211.192-.035.3846-.1558.5354-.1209.1507-.2967.2473-.4887.2684-.7088.0882-1.422.1365-2.1363.1448Zm17.8719-21.0002c-.1735.0023-.3421-.0579-.4751-.1696-.1329-.1116-.2213-.2673-.249-.4387-.616-3.7676-2.45-7.2295-5.2211-9.8556-.077-.0629-.1403-.1411-.1857-.2295-.0455-.0885-.0723-.1854-.0787-.2846-.0064-.0993.0078-.19883.0415-.2924.0338-.09356.0865-.17917.1548-.25147.0683-.07231.1508-.12976.2423-.16879.0915-.03902.1901-.05877.2895-.05802.0995.00075.1978.02199.2887.06239.0909.0404.1725.09909.2397.17242 3.0043 2.84277 4.9935 6.59227 5.6628 10.67387.0166.0942.0144.1908-.0065.2841-.0209.0933-.0601.1816-.1153.2597-.0552.0781-.1254.1445-.2064.1953-.081.0509-.1713.0852-.2656.1009h-.1159Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
EmailCommunication.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Network"
};
validateTidalLicense();
export {
  EmailCommunication
};
//# sourceMappingURL=EmailCommunication.js.map
